var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-local-offer",
    "data-name": "Icon material-local-offer",
    d: "M17.558,10.185l-6.75-6.75A1.491,1.491,0,0,0,9.75,3H4.5A1.5,1.5,0,0,0,3,4.5V9.75a1.5,1.5,0,0,0,.443,1.065l6.75,6.75A1.491,1.491,0,0,0,11.25,18a1.466,1.466,0,0,0,1.057-.442l5.25-5.25A1.466,1.466,0,0,0,18,11.25a1.515,1.515,0,0,0-.442-1.065ZM5.625,6.75A1.125,1.125,0,1,1,6.75,5.625,1.123,1.123,0,0,1,5.625,6.75Z",
    transform: "translate(-2.5 -2.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferIcon);
export default __webpack_public_path__ + "static/media/offer-icon.0c945f6d1c1a73e237c7c4ca697f9659.svg";
export { ForwardRef as ReactComponent };